(function () {
  const carousels = document.querySelectorAll('[data-accessory-carousel]');

  carousels.forEach(function (carousel) {
    const container = carousel.querySelector('.accessory-container');
    const items = Array.from(
      carousel.querySelectorAll('.accessory-item')
    );

    const leftArrow = carousel.querySelector('.accessory-arrow.left-arrow');
    const rightArrow = carousel.querySelector('.accessory-arrow.right-arrow');

    if (!container || !items.length || !leftArrow || !rightArrow) {
      return;
    }

    let scrollAmount = 0;

    function scrollCarousel(direction) {
      const itemWidth = items[0].offsetWidth + 20;
      const maxScroll = container.scrollWidth - container.clientWidth;

      scrollAmount += direction * itemWidth;

      if (scrollAmount > maxScroll) {
        scrollAmount = maxScroll;
      }

      if (scrollAmount < 0) {
        scrollAmount = 0;
      }

      container.scrollTo({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }

    rightArrow.addEventListener('click', function () {
      scrollCarousel(1);
    });

    leftArrow.addEventListener('click', function () {
      scrollCarousel(-1);
    });

    container.addEventListener('scroll', function () {
      scrollAmount = container.scrollLeft;
    });

    window.addEventListener('resize', function () {
      scrollAmount = container.scrollLeft;
    });
  });
})();